<template>
<div class="contact">
    <div class="body__bg" ref="bodyOpacity"></div>
    <vHeader @enableDimming="enableDimming" @closeDimming="closeDimming()" @headerModelOpen="headerModelOpen"></vHeader>
    <div class="container">
        <div class="contact__block">
            <div class="contact__bg-1">
                <img src="/img/contact/4328245.png" alt="" />
            </div>
            <div class="contact__bg-2">
                <img src="/img/contact/spinach.png" alt="" />
            </div>
            <div class="contact__bg-3"> <img src="/img/list-bg-2.png" alt="" /></div>
            <div class="contact__bg-4">
                <img src="/img/list-bg-4.png" alt="" />
            </div>
            <div class="contact__bg-5">
                <img src="/img/list-bg-3.png" alt="" />
            </div>
            <div class="contact__arrow-1">
                <img src="/img/arrow-spiral-3.svg" alt="" />
            </div>
            <div class="contact__block-left">
                <h2 class="contact__block-title">FIRMA OÜ</h2>
                <div class="contact__block-item">
                    <div class="contact__block-img">
                        <img src="/img/contact/icon-exclude-1.svg" alt="" />
                    </div>
                    <div class="contact__block-text">
                        Регистрационный код: <span>14881025</span>
                    </div>
                </div>
                <div class="contact__block-item">
                    <div class="contact__block-img">
                        <img src="/img/contact/icon-exclude-2.svg" alt="" />
                    </div>
                    <div class="contact__block-text">
                        Налоговый номер: <span>EE25036545</span>
                    </div>
                </div>
                <div class="contact__block-item">
                    <div class="contact__block-img">
                        <img src="/img/contact/icon-exclude-3.svg" alt="" />
                    </div>
                    <div class="contact__block-text">
                        Адрес: <span>Laki 14A, Tallinn, 10621,Eesti</span>
                    </div>
                </div>
                <div class="contact__block-item">
                    <div class="contact__block-img">
                        <img src="/img/contact/icon-exclude-4.svg" alt="" />
                    </div>
                    <div class="contact__block-text">
                        <span>keto-dieet@dieedid.ee</span>
                    </div>
                </div>
                <div class="contact__block-item">
                    <div class="contact__block-img">
                        <img src="/img/contact/icon-exclude-5.svg" alt="" />
                    </div>
                    <div class="contact__block-text"><span>+372 55 546 44</span></div>
                </div>
            </div>
            <div class="contact__block-right">
                <div style="position:relative;overflow:hidden;">
                    <a href="https://yandex.ru/maps/145/odesa/?utm_medium=mapframe&utm_source=maps" style="color:#eee;font-size:12px;position:absolute;top:0px;"></a><a href="https://yandex.ru/maps/145/odesa/?ll=30.748231%2C46.395970&utm_medium=mapframe&utm_source=maps&z=16" style="color:#eee;font-size:12px;position:absolute;top:14px;"></a><iframe src="https://yandex.ru/map-widget/v1/-/CCUMF8uyKA" width="560" height="465" frameborder="1" allowfullscreen="true" style="position:relative; border: 0"></iframe>
                </div>
            </div>
        </div>
    </div>
    <vFooter></vFooter>
    <vHeaderModel v-if="showModelHeader"></vHeaderModel>
</div>
</template>

<script>
import vHeader from "./v-header";
import vFooter from "./v-footer";
import vHeaderModel from './v-enter-model'

export default {
    name: 'contact',
    data() {
        return {
            showModelHeader: false
        }
    },
    components: {
        vHeader,
        vFooter,
        vHeaderModel
    },
    methods: {
        enableDimming() {
            this.$refs.bodyOpacity.style.display = 'block';
        },
        closeDimming() {
            this.$refs.bodyOpacity.style.display = 'none';
        },
        headerModelOpen() {
            this.showModelHeader = true;
            this.$refs.bodyOpacity.onclick = () => {
                this.showModelHeader = false;
                this.closeDimming()
            }
        }
    },
    mounted() {
        document.querySelector('.contact').style.opacity = '1';
    }
};
</script>

<style>
body {
    background-image: url(/img/fon.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}

.contact {
    opacity: 0;
    transition: all .4s;
}

.footer {
    color: #fff;
}

.contact__block {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 80px;
    padding-bottom: 180px;
    position: relative;
}

.contact .header__right-openPr {
    display: block !important;
}

.contact .header__right-lauguage {
    margin-right: 0 !important;
}

.contact .header__right-lauguage {
    margin: 0;
}

.contact .footer__bottom-bg {
    display: none !important;
}

.contact .footer__top {
    padding: 30px 0 20px 0;
}

.contact .footer:before {
    top: 81px;
}

.contact .footer__bottom {
    display: flex;
    align-items: center;
    padding: 0;
}

.contact__bg-1,
.contact__bg-2,
.contact__bg-3,
.contact__bg-4,
.contact__bg-5,
.contact__arrow-1 {
    position: absolute;
    z-index: -1;
}

.contact .contact__bg-1 img {
    width: 600px;
    height: 417px;
}

.contact .contact__bg-2 {
    top: 12%;
    left: 16%;
}

.contact .contact__bg-1 {
    bottom: -110px;
    left: -75px;
}

.contact .contact__bg-3 {
    bottom: 16%;
    left: -40%;
    transform: rotate(-110deg);
}

.contact__bg-4 img {
    width: 154px;
    height: 101px;
}

.contact__bg-4 {
    top: -10%;
    left: 46%;
    transform: rotate(150deg);
}

.contact__bg-5 {
    right: -30%;
    bottom: -10%;
    z-index: 50;
}

.contact__arrow-1 {
    top: -4%;
    left: 42%;
    transform: rotate(50deg);
}

.contact__block-title {
    font-size: 73.9556px;
    line-height: 85px;
    color: #fff599;
    font-family: "Roboto-Bold";
    margin-bottom: 30px;
    margin-top: -40px;
}

.contact__block-img {
    width: 42px;
    text-align: center;
}

.contact__block-item {
    display: flex;
    align-items: center;
    font-size: 22px;
    line-height: 30px;
    color: #fff599;
    font-family: "Roboto-Bold";
    margin-bottom: 17px;
}

.contact__block-text {
    margin-left: 20px;
}

.contact__block-right div {
    position: relative;
    width: 590px;
    height: 494px;
    padding: 15px 0 0 20px;
    filter: drop-shadow(0px 10px 5px rgba(0, 0, 0, 0.25));
}

.contact__block-right div:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(/img/contact/border.png);
    top: 0;
    left: 0px;
}

@media (max-width: 1850px) {
    .contact__bg-5 {
        right: -20%;
    }
}

@media (max-width: 1650px) {
    .contact__bg-5 {
        right: -10%;
    }
}

@media (max-width: 1400px) {
    .contact__bg-5 {
        right: 0%;
    }
}

@media (max-width: 1100px) {
    .contact__block-right div {
        width: 390px;
        height: 404px;
    }

    .contact__block-right div:before {
        background-image: url(/img/contact/border-2.png);
        background-repeat: no-repeat;
    }

    .contact__block-right iframe {
        width: 346px;
        height: 337px;
        margin: -6px 0px 0 -7px;
    }

    .contact__bg-4 {
        left: 58%;
    }

    .contact__arrow-1 {
        left: 54%;
    }

    .contact .contact__bg-1 {
        background-image: url(/img/contact/4328245.png);
        width: 416px;
        height: 270px;
        left: -10px;
        bottom: 0;
        background-size: cover;
    }

    .contact__bg-1 img {
        display: none;
    }

    .contact__block-text {
        font-size: 18px;
    }

    .contact__block-img img,
    .contact__block-img {
        width: 29px;
        height: 29px;
    }

    .contact__bg-2 {
        display: block;
    }

    .contact__block-title {
        font-size: 60px;
    }
}

@media (max-width: 980px) {
    .contact__arrow-1 {
        left: 40%;
    }
}

@media (max-width: 765px) {
    .contact {
        overflow: hidden;
    }

    .contact__block {
        flex-direction: column;
        align-items: center;
        padding-bottom: 0;
    }

    .contact__bg-4 {
        right: -5%;
        left: auto;
        top: -10%;
        transform: rotate(10deg);
        width: 110px;
    }

    .contact__bg-1 {
        display: none;
    }

    .contact__arrow-1 {
        display: none;
    }
}

@media (max-width: 650px) {
    .contact__bg-3 {
        display: none;
    }

    .contact__block-title {
        font-size: 36px;
        margin-bottom: 0px;
    }
}

@media (max-width: 400px) {
    .contact__bg-5 {
        display: none;
    }

    .contact__block-text {
        font-size: 16px;
        margin-left: 15px;
    }

    .contact__block-right div {
        width: 320px;
        height: 320px;
    }

    .contact__block-right div:before {
        background-image: url(/img/contact/border-3.png);
    }

    .contact__block-right iframe {
        width: 304px;
        height: 296px;
        margin: -6px 0px 0 -12px;
    }

    .contact__block-right {
        margin-bottom: 40px;
    }
}
</style>
